import React, { useState, useEffect } from "react";

function AvatarCustomizer({ initialOptions, onSave, onCancel }) {
  const [avatarOptions, setAvatarOptions] = useState(initialOptions || {});
  const [avatarUrl, setAvatarUrl] = useState("");

  // Generar la URL del avatar cada vez que cambian las opciones
  useEffect(() => {
    const baseUrl = "https://api.dicebear.com/9.x/adventurer-neutral/svg";
    const params = new URLSearchParams();

    Object.keys(avatarOptions).forEach((key) => {
      const value = avatarOptions[key];
      if (value !== undefined && value !== "") {
        params.append(key, value);
      }
    });

    setAvatarUrl(`${baseUrl}?${params.toString()}`);
  }, [avatarOptions]);

  // Manejar cambios en las opciones del avatar
  const handleOptionChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAvatarOptions((prevOptions) => ({
      ...prevOptions,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Listas de opciones disponibles
  const seedOptions = [
    "Adventurer",
    "Alchemist",
    "Archer",
    "Assassin",
    "Bard",
    "Beastmaster",
    "Berserker",
    "Chieftain",
    "Champion",
    "Commander",
    "Conqueror",
    "Crusader",
    "Defender",
    "Drifter",
    "Druid",
    "Elementalist",
    "Enchanter",
    "Engineer",
    "Explorer",
    "Gladiator",
    "Guardian",
    "Gunslinger",
    "Healer",
    "Hero",
    "Hunter",
    "Illusionist",
    "Invoker",
    "Knight",
    "Mage",
    "Martial Artist",
    "Mercenary",
    "Monk",
    "Mystic",
    "Necromancer",
    "Nomad",
    "Oracle",
    "Paladin",
    "Pioneer",
    "Priest",
    "Psychic",
    "Ranger",
    "Rogue",
    "Samurai",
    "Sage",
    "Scout",
    "Seeker",
    "Shaman",
    "Sorcerer",
    "Summoner",
    "Templar",
    "Thief",
    "Traveler",
    "Viking",
    "Voyager",
    "Wanderer",
    "Warlord",
    "Warrior",
    "Wayfarer",
    "Wizard",
    "Zealot",
  ];

  const flipOptions = [
    { value: true, label: "Sí" },
    { value: false, label: "No" },
  ];

  const eyesOptions = [
    "variant01",
    "variant02",
    "variant03",
    "variant04",
    "variant05",
    "variant06",
    "variant07",
    "variant08",
    "variant09",
    "variant10",
  ];

  const eyebrowsOptions = [
    "variant01",
    "variant02",
    "variant03",
    "variant04",
    "variant05",
    "variant06",
    "variant07",
    "variant08",
    "variant09",
    "variant10",
  ];

  const mouthOptions = [
    "variant01",
    "variant02",
    "variant03",
    "variant04",
    "variant05",
    "variant06",
    "variant07",
    "variant08",
    "variant09",
    "variant10",
  ];

  return (
    <div>
      <h2 className="mb-4 text-xl font-bold">Personaliza tu Avatar</h2>
      <div className="flex flex-col md:flex-row">
        {/* Sección de opciones */}
        <div
          className="w-full overflow-y-auto md:w-2/3 md:pr-10"
          style={{ maxHeight: "70vh" }}
        >
          <div className="space-y-4">
            {/* Seed */}
            <div>
              <label className="block text-gray-700">Semilla:</label>
              <select
                name="seed"
                value={avatarOptions.seed || ""}
                onChange={handleOptionChange}
                className="w-full rounded border px-3 py-2"
              >
                <option value="">Seleccione</option>
                {seedOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            {/* Flip */}
            <div className="flex items-center">
              <input
                type="checkbox"
                name="flip"
                checked={avatarOptions.flip || false}
                onChange={handleOptionChange}
                className="mr-2"
                id="flip"
              />
              <label htmlFor="flip" className="text-gray-700">
                Voltear Horizontalmente
              </label>
            </div>

            {/* Ojos */}
            <div>
              <label className="block text-gray-700">Ojos:</label>
              <select
                name="eyes"
                value={avatarOptions.eyes || ""}
                onChange={handleOptionChange}
                className="w-full rounded border px-3 py-2"
              >
                <option value="">Seleccione</option>
                {eyesOptions.map((option) => (
                  <option key={option} value={option}>
                    {`Variante ${option.slice(-2)}`}
                  </option>
                ))}
              </select>
            </div>

            {/* Cejas */}
            <div>
              <label className="block text-gray-700">Cejas:</label>
              <select
                name="eyebrows"
                value={avatarOptions.eyebrows || ""}
                onChange={handleOptionChange}
                className="w-full rounded border px-3 py-2"
              >
                <option value="">Seleccione</option>
                {eyebrowsOptions.map((option) => (
                  <option key={option} value={option}>
                    {`Variante ${option.slice(-2)}`}
                  </option>
                ))}
              </select>
            </div>

            {/* Boca */}
            <div>
              <label className="block text-gray-700">Boca:</label>
              <select
                name="mouth"
                value={avatarOptions.mouth || ""}
                onChange={handleOptionChange}
                className="w-full rounded border px-3 py-2"
              >
                <option value="">Seleccione</option>
                {mouthOptions.map((option) => (
                  <option key={option} value={option}>
                    {`Variante ${option.slice(-2)}`}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Sección de vista previa del avatar */}
        <div className="mt-4 flex w-full flex-col items-center justify-center md:mt-0 md:w-1/3">
          {/* Vista previa del avatar */}
          <img
            src={avatarUrl}
            alt="Vista previa del avatar"
            className="h-64 w-64"
          />
          {/* Botones de acción */}
          <div className="mt-4 flex justify-end">
            <button
              type="button"
              onClick={onCancel}
              className="mr-4 rounded bg-gray-500 px-4 py-2 text-white"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={() => onSave(avatarUrl)}
              className="rounded bg-green-500 px-4 py-2 text-white"
            >
              Guardar Avatar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AvatarCustomizer;
